module.exports = __webpack_public_path__ + "img/wj_wsxx_copy.a536c6d8.png";